import React from 'react';

export default ({ color = '#8E95AA', size = 19 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0338 3.00781H6.96712C4.781 3.00781 3.00879 4.78002 3.00879 6.96615V12.0328C3.00879 14.2189 4.781 15.9911 6.96712 15.9911H12.0338C14.2199 15.9911 15.9921 14.2189 15.9921 12.0328V6.96615C15.9921 4.78002 14.2199 3.00781 12.0338 3.00781Z"
      stroke={color}
      strokeWidth="1.34583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.49961 12.5891C11.2048 12.5891 12.5871 11.2067 12.5871 9.50156C12.5871 7.79638 11.2048 6.41406 9.49961 6.41406C7.79443 6.41406 6.41211 7.79638 6.41211 9.50156C6.41211 11.2067 7.79443 12.5891 9.49961 12.5891Z"
      stroke={color}
      strokeWidth="1.34583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.2209 6.61172C13.68 6.61172 14.0521 6.23956 14.0521 5.78047C14.0521 5.32138 13.68 4.94922 13.2209 4.94922C12.7618 4.94922 12.3896 5.32138 12.3896 5.78047C12.3896 6.23956 12.7618 6.61172 13.2209 6.61172Z"
      fill={color}
    />
  </svg>
);
